import React, { useEffect } from "react";

/**
 * KeyShield
 *  - Stops plain-letter global hotkeys (like "m") from firing while typing
 *  - Works in capture phase so downstream listeners won't receive the event
 *  - Does NOT preventDefault, so your typed character still appears in the field
 */
export default function KeyShield() {
  useEffect(() => {
    const isTypingTarget = (el) => {
      if (!el) return false;
      const tag = (el.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || tag === "select") return true;
      // ContentEditable elements
      if (el.isContentEditable) return true;
      return false;
    };

    const onKeyDownCapture = (e) => {
      // ignore modified combos; we only shield unmodified single-key hotkeys
      if (e.ctrlKey || e.metaKey || e.altKey) return;

      if (isTypingTarget(e.target)) {
        // Let typing continue normally but block bubbling to global handlers
        // that listen on window/document/body.
        // This prevents things like a global "m" hotkey from triggering.
        e.stopPropagation();
      }
    };

    // capture = true so we intercept before other handlers
    window.addEventListener("keydown", onKeyDownCapture, true);
    return () => window.removeEventListener("keydown", onKeyDownCapture, true);
  }, []);

  return null;
}
